var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50011 9.79167L1.63831 4.58117C1.06559 4.0721 1.42568 3.125 2.19194 3.125H17.7322C18.3718 3.125 18.7729 3.81561 18.4561 4.37115L10.8343 17.7365C10.4588 18.3949 9.47071 18.2509 9.29876 17.5128L7.50011 9.79167ZM7.50011 9.79167L18.8217 3.33333",
    stroke: "#242629",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.98d5864ea7549be5a5d5da225e364b03.svg";
export { ForwardRef as ReactComponent };